import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { Tag, Form, DatePicker, Select, Button } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { API_DEVICE, API_TRENDS } from '../../../../../commons/api';
import themeSettings from '../../../../../commons/styles/themeSettings.json';

const { Option } = Select;
const { RangePicker } = DatePicker;

const layout = {
  wrapperCol: {
    offset: 9
  }
};

const LineWithSelection = (props) => {
  const getInitialOption = () => {
    const theme = props.selectedThemeing;
    return {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [{ name: 'test1', icon: 'roundRect' }]
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: theme === 'lightTheme' ? 'black' : 'black',
            title: 'download',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white'
        }
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',
          textStyle: {
            color: 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ]
    };
  };

  const [option, setOption] = useState(getInitialOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [formObject, setFormObject] = useState({});
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment('2023-11-04 13:00:00').format('YYYY-MM-DD HH:mm:ss'),
    endDate: moment('2023-11-04 13:30:00').format('YYYY-MM-DD HH:mm:ss')
  });
  const [graphTypeList] = useState([
    { Code: 'line', Name: 'Line' },
    { Code: 'scatter', Name: 'Scatter' }
  ]);
  const [deviceList, setDeviceList] = useState([]);
  const LineRef = useRef(null);
  const abortController = useRef(new window.AbortController());

  useEffect(() => {
    getDeviceData();
    const refreshTime = props.graphprops.refreshTime ? props.graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    const ticket = setInterval(() => {
      // Refresh logic can be added here
    }, refreshTime);

    return () => {
        abortController.current.abort();
      clearInterval(ticket);
    };
  }, [props]);

  useEffect(() => {
    getDeviceData();
  }, [props.graphprops, props.selectionDate, props.selectionDateLive, props.selectionMonth, props.selectionWeek, props.DeviceCode, props.shift, props.selectionDateRange, props.dayMonthYear, props.dropdownSelection, props.dashboardPayload, props.AssetCode, props.translationCache]);

  const getDeviceData = async () => {
    try {
      const { dropdownSelection } = props;
      const deviceCode = dropdownSelection?.DeviceCode || '';
  
      const deviceList = await getList(deviceCode);
      setDeviceList(deviceList);
  
      if (deviceList.length < 2) {
        console.error('Not enough parameters in device list');
        return;
      }
  
      const param1 = deviceList[0]?.ParameterCode || '';
      const param2 = deviceList[1]?.ParameterCode || '';
      const graph = graphTypeList[0]?.Code || '';
  
      const payload = {
        FromDate: moment(selectedDate.startDate).utc().format('YYYY-MM-DD HH:mm:ss'),
        GraphType: graph,
        Interval: '1m',
        Operator: 'AVG',
        ParameterList: [
          { DeviceAlias: deviceCode, ParameterCode: param1 },
          { DeviceAlias: deviceCode, ParameterCode: param2 }
        ],
        SiteId: '21',
        ToDate: moment(selectedDate.endDate).utc().format('YYYY-MM-DD HH:mm:ss'),
        Type: 'historic',
        ViewType: 'Single'
      };
  
       await getGraphData(payload);
  
      setFormObject({ xAxis: param1, yAxis: param2, graphType: graph, Date: [moment(selectedDate.startDate), moment(selectedDate.endDate)] });
  
      if (LineRef.current) {
        LineRef.current.setFieldsValue({ xAxis: param1, yAxis: param2, graphType: graph });
      }
    } catch (error) {
      console.error('Error fetching device data:', error.response ? error.response.data : error.message);
      setErrorInAPI(true); 
    }
  };

  const getList = async (deviceCode) => {
    if (!deviceCode) {
      console.error('Device code is required');
      return [];
    }
  
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const url = `${API_DEVICE.GetDeviceParamsByType}?SiteId=${siteId}`;
    const payload = {
      Device: deviceCode,
      ParameterType: 'Operational'
    };
  
    try {
      const response = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching device list:', error.response ? error.response.data : error.message);
      throw error; 
    }
  };

const getGraphData = async (payload) => {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  
  const url = `${API_TRENDS.LIST}?SiteId=${siteId}`;

  try {
    const response = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching graph data:', error.response ? error.response.data : error.message);
    throw error; 
  }
};

  const onChange = (value) => {
    setSelectedDate({
      startDate: moment.utc(value[0]).format('YYYY-MM-DD HH:mm'),
      endDate: moment.utc(value[1]).format('YYYY-MM-DD HH:mm')
    });
  };

  const onFormsubmit = async (values) => {
    const { deviceCode } = props;
    const { graphType, xAxis, yAxis } = values;
    const siteId = localStorage.get('currentSite');
    const payload = {
      FromDate: moment.utc(selectedDate.startDate).format('YYYY-MM-DD HH:mm:ss'),
      GraphType: 'line',
      Interval: '1m',
      Operator: 'AVG',
      ParameterList: [
        { DeviceAlias: deviceCode, ParameterCode: xAxis },
        { DeviceAlias: deviceCode, ParameterCode: yAxis }
      ],
      SiteId: siteId,
      ToDate: moment.utc(selectedDate.endDate).format('YYYY-MM-DD HH:mm:ss'),
      Type: 'historic',
      ViewType: 'Single'
    };
    await getData(payload, graphType);
  };

  const handleChange = async (value, key) => {
    const updatedFormObject = { ...formObject, [key]: value };
    if (key === 'graphType') {
      setFormObject(updatedFormObject);
    }
    if (LineRef.current) LineRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const getData = async (payload, graphType) => {
    let json = await getGraphData(payload);
    let tagList = [];
    let ArryList = [];

    if (json && json.message) {
      setErrorInAPI(true);
    } else if (Array.isArray(json) && json.length === 0) {
      setNoDataInDB(true);
    } else {
      tagList = _.chain(json).map('ParameterName').uniq().value();
      const Dates = _.chain(json).map('DateTime').uniq().value();
      ArryList = Dates.map((date) => {
        const filterobj = json.filter((d) => d.DateTime === date);
        return [filterobj[0].Value, filterobj[1].Value, date];
      });

      const option = {
        xAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: props.graphprops.line?.Linecolor?.[0] || 'white'
            }
          }
        },
        yAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: props.graphprops.line?.Linecolor?.[0] || 'white'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            return `<span>${params[0].data[2]}</br>${tagList[0]}: ${params[0].data[0]}</br>${tagList[1]}: ${params[0].data[1]}</span>`;
          }
        },
        series: [
          {
            symbolSize: graphType === 'scatter' ? 10 : 2,
            data: ArryList,
            type: graphType
          }
        ]
      };

      setOption(option);
      setRefreshDateTime(moment());
    }
  };



  return (
    <Fragment>
      <div style={{ float: 'left', width: '45%', height: '90%', marginLeft: '10px' }}>
        <Form
          name="Item"
          theme={themeSettings}
          ref={LineRef}
          initialValues={formObject}
          onFinish={onFormsubmit}
          labelCol={{ span: 9 }}
          wrapperCol={{ span: 20 }}
          layout="horizontal"
        >
          <Form.Item
            style={{ marginTop: '15%' }}
            name="xAxis"
            label="Select X-Axis"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={'Select XAxis'}
              onChange={(e) => handleChange(e, 'xAxis')}
            >
              {deviceList.map((deviceType, index) => (
                <Option key={index} value={deviceType.ParameterCode}>
                  {deviceType.ParameterName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Select Y-Axis"
            name="yAxis"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={'Select YAxis'}
              onChange={(e) => handleChange(e, 'yAxis')}
            >
              {deviceList.map((deviceType, index) => (
                <Option key={index} value={deviceType.ParameterCode}>
                  {deviceType.ParameterName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Select DateRange"
            name="Date"
            rules={[{ required: true, message: 'Please Select Date Selection' }]}
          >
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              value={[moment(selectedDate.startDate), moment(selectedDate.endDate)]}
              onChange={onChange}
            />
          </Form.Item>

          <Form.Item
            name="graphType"
            label="Select GraphType"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={'Select GraphType'}
              onChange={(e) => handleChange(e, 'graphType')}
            >
              {graphTypeList.map((graphType, index) => (
                <Option key={index} value={graphType.Code}>
                  {graphType.Name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item {...layout}>
            <Button type='primary' htmlType="submit">
              {'Submit'}
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div style={{ float: 'right', width: '50%', height: '100%', borderLeft: '1px dashed white' }}>
        {props.graphprops.checked && (
          <Tag className="graphTag" color="blue">
            {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Tag>
        )}
        {noDataInDB || errorInAPI ? (
          noDataInDB ? (
            <NoRecordComponent />
          ) : (
            <ErrorComponent />
          )
        ) : (
          <ReactEcharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            style={{ height: '80%', width: '100%' }}
            className="react_for_echarts"
          />
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache
  };
};

export default connect(mapStateToProps)(LineWithSelection);